import React, { useEffect, useState } from "react";
import servicosProduto from "../../servicos/servicos-produto";
import MenuLateral from "./MenuLateral";
import NavMenu from "./Nav";
import { ToastContainer, toast } from 'react-toastify';
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import Salvar from "../../img/svgs/Salvar";
import servicosImagens from "../../servicos/servicos-imagens";

const dadosProduto = {
    "nome": "",
    "tamanho": "",
    "cor": "",
    "estoque": 0,
    "milhas": 0,
    "categoria": 1,
    "arquivo": []
}

const CadastroProduto = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [data, setData] = useState(dadosProduto);
    const [produtos, setProdutos] = useState([]);

    const clearData = () => {
        const nome = document.querySelector('#nome');
        const tamanho = document.querySelector('#tamanho');
        const cor = document.querySelector('#cor');
        const estoque = document.querySelector('#estoque');
        const milhas = document.querySelector('#milhas');
        const arquivo = document.querySelector('#arquivo');

        nome.value = '';
        tamanho.value = '';
        cor.value = '';
        estoque.value = '';
        milhas.value = '';
        arquivo.value = '';
    }
    const handleChange = (e) => {
        let { name, value } = e.target;
        if(name === 'categoria'){
            setSelectedValue(value);
        }
        if (name === 'estoque' || name === "milhas" || name === "categoria") {
            value = Number(value);
        }
        setData({ ...data, [name]: value });

    }

    const handleArquivoChange = (e) => {
        setData({ ...data, arquivo: e.target.files });
    }

    useEffect(() => {
        servicosProduto.listarTodosCategoria1().then(
            response => {
                setProdutos(response.data)
            }
        )
    }, [])

    const criarProduto = async () => {
        let flagRepetido = false;
        produtos.forEach(element => {
            if (element.nome === data.nome && element.tamanho === data.tamanho) {
                flagRepetido = true;
            }
        });

        if (!flagRepetido) {
            if (data.arquivo.length <= 4) {
                let id = '';
                await servicosProduto.create(data)
                    .then(response => {
                        if (response.status === 201) {
                            id = response.data.novoProdutoCriado.id_produto;

                            if (data.arquivo.length > 0) {
                                servicosImagens.create(id, data.arquivo).then(response => {
                                    if (response.status === 201) {
                                        toast.success("Produto cadastrado com sucesso!", {
                                            theme: "colored",
                                        });
                                        clearData();
                                        return;
                                    } else {
                                        toast.error("Produto foi cadastrado, mas não foi possível adicionar as imagens!", {
                                            theme: "colored",
                                        });
                                        return;
                                    }
                                }).catch(
                                    e => {
                                        console.log(e);
                                        toast.error("Produto foi cadastrado, mas não foi possível adicionar as imagens!", {
                                            theme: "colored",
                                        });
                                        return;
                                    }
                                )

                            } else {
                                toast.success("Produto cadastrado com sucesso!", {
                                    theme: "colored",
                                });
                                clearData();
                                return;
                            }

                        }
                    })
                    .catch(e => {
                        console.log(e);
                        toast.error("Não foi possível cadastrar o Produto!", {
                            theme: "colored"
                        });
                    })

            } else {
                toast.warn("Só pode ser enviado 4 imagens por produto!", {
                    theme: "colored",
                });
            }
        } else {
            toast.error("Este produto já foi adicionado!", {
                theme: "colored"
            });
        }

    }

    const [selectedValue, setSelectedValue] = useState("1");

    
    const SelectCategoria = () => {
        return <>
            <select className="form-select w-25 mb-4 input-cadastro" name="categoria" value={selectedValue}  onChange={ (e) => handleChange(e)}   aria-label="Exemplo de select simples">
                <option value="1">Simples</option>
                <option value="2">Producão</option>
                <option value="4">Gestores</option>
            </select>
        </>
    }

    return <>
        <NavMenu />
        <ToastContainer />
        <div className="d-flex container">
            <div className="w-25">
                <MenuLateral />
            </div>
            <div className="w-75 mt-3">
                <form className="cadastros" onSubmit={handleSubmit(criarProduto)}>
                    <Form.Group className="mb-3" controlId="nome">
                        <Form.Label className="label-texto">Nome</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="text"
                            name="nome"
                            {...register("nome", { required: true, minLength: 2 })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.nome && <p className="errosValidacao">Requerido mínimo 2 letras</p>}

                    <Form.Group className="mb-3" controlId="tamanho">
                        <Form.Label className="label-texto">Tamanho</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="text"
                            name="tamanho"
                            {...register("tamanho", { required: false })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.tamanho && <p className="errosValidacao">Requerido mínimo 2 letras</p>}

                    <Form.Group className="mb-3" controlId="cor">
                        <Form.Label className="label-texto">Cor</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="text"
                            name="cor"
                            {...register("cor", { required: false })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.cor && <p className="errosValidacao">Requerido mínimo 2 letras</p>}

                    <Form.Group className="mb-3" controlId="estoque">
                        <Form.Label className="label-texto">Estoque</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="number"
                            name="estoque"
                            {...register("estoque", { required: true, minLength: 1 })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.estoque && <p className="errosValidacao">Requerido informar o estoque atual</p>}

                    <Form.Group className="mb-3" controlId="milhas">
                        <Form.Label className="label-texto">Milhas</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="number"
                            name="milhas"
                            {...register("milhas", { required: true, minLength: 1 })}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    {errors.milhas && <p className="errosValidacao">Requerido informar o valor do produto</p>}

                    <Form.Group className="mb-3" controlId="categoria">
                        <Form.Label className="label-texto">Categoria</Form.Label>
                        <SelectCategoria />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="arquivo">
                        <Form.Label className="label-texto">Imagens do produto</Form.Label>
                        <Form.Control
                            className="input-cadastro"
                            type="file"
                            multiple
                            name="arquivo"
                            {...register("arquivo", { required: false })}
                            onChange={handleArquivoChange}
                        />
                    </Form.Group>
                    <button type="submit" className="btn-icones rounded p-1"><Salvar /> Salvar</button>
                </form>
            </div>
        </div>
    </>
}

export default CadastroProduto;